import { Carousel } from '@mantine/carousel'
import { Skeleton, Box } from '@mantine/core'
import { useTranslations } from 'next-intl'
import TitleDivider from './divider'
import NextSmallSVG from './buttons/next_carousel_button_small'
import PreviousSmallSVG from './buttons/previous_carousel_button_small'
import CharacterCard from './character_card'
import Link from 'next/link'

const CrewCarousel = ({ crew, isLoading, title }) => {
  const t = useTranslations('CrewCarousel')

  if (isLoading) {
    return (
      <Box sx={{ width: '100%' }} p="md">
        {[...Array(5)].map((_, index) => (
          <Skeleton key={index} height={200} radius="md" animate={true} />
        ))}
      </Box>
    )
  }

  if (!crew || crew.length === 0) {
    return null
  }

  const filteredCrew = crew.filter(
    (person) =>
      person.job === t('director') ||
      person.job === t('producer') ||
      person.job === t('executiveProducer')
  )

  const crewMap = filteredCrew.reduce((acc, person) => {
    if (acc[person.name]) {
      acc[person.name].roles.push(person.job)
    } else {
      acc[person.name] = {
        name: person.name,
        roles: [person.job],
        src: person.image
      }
    }
    return acc
  }, {})

  const combinedCrew = Object.values(crewMap)

  if (combinedCrew.length === 0) {
    return null
  }

  return (
    <Box mt={24}>
      <TitleDivider
        titleText={t('crewTitle').toUpperCase() + title.toUpperCase()}
        epgText=""
      />

      <Carousel
        height={300}
        width="100%"
        mt={30}
        slideGap="sm"
        slideSize="10%"
        loop={false}
        align="start"
        slidesToScroll={5} // Usar valores responsivos directamente aquí
        nextControlIcon={<NextSmallSVG top={-140} width="100" height="280" />}
        previousControlIcon={
          <PreviousSmallSVG top={-140} width="100" height="280" />
        }
        styles={{
          control: {
            opacity: 1,
            cursor: 'default',
            backgroundColor: 'transparent',
            border: 'transparent',
            transform: 'none',
            transition: 'none',
            '&[data-inactive]': {
              opacity: 0,
              cursor: 'default',
              visibility: 'hidden',
              pointerEvents: 'none',
              width: 0,
              margin: 0
            },
            '@media (max-width: 768px)': {
              display: 'none'
            }
          }
        }}
      >
        {combinedCrew.map((person, index) => (
          <Carousel.Slide key={index}>
            <Link href={`/search?q=${person.name}`} prefetch={false} passHref>
              <CharacterCard
                name={person.name}
                role={person.roles.join(', ')}
                src={person.src}
              />
            </Link>
          </Carousel.Slide>
        ))}
      </Carousel>
    </Box>
  )
}

export default CrewCarousel
